import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import { Markdown, Notice } from '@applyboard/crystal-ui';
import { useTranslation } from 'react-i18next';
import { assert } from "../../../../utils/assert";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function UnpublishedProgramsNotice(_ref) {
  var programNames = _ref.programNames;
  var _useTranslation = useTranslation('UnpublishedProgramsNotice'),
    t = _useTranslation.t;
  assert(programNames.length > 0, 'UnpublishedProgramsNotice should not be rendered with an empty array');
  var formattedProgramNames = programNames.map(function (name) {
    return "**\u201C".concat(name, "\u201D**");
  });
  return _jsx(Notice, {
    intent: "warning",
    children: _jsx(Markdown, {
      headingSettings: {
        baseLevel: 2
      },
      markdown: t('noticeText', {
        count: formattedProgramNames.length,
        init: formattedProgramNames.slice(0, -1).join(', '),
        last: formattedProgramNames.at(-1)
      })
    })
  });
}